<template>
  <section>
    <v-container class="px-6">
      <v-card>
        <v-toolbar color="primary" dark flat>
          <v-card-title class="text-h4 font-weight-black">PRICING</v-card-title>
        </v-toolbar>
        <v-card-subtitle class="title text-right">From <span class="font-weight-bold text-h5">$30/m</span> for 0-500 members.</v-card-subtitle>
        <v-card-text>
          <p class="text-h6 font-weight-light text-center">Your first 14 days are FREE and you can cancel your subscription at any time!</p>
          <v-list two-line subheader>
            <v-list-item v-for="item in featuresByType(['base', 'base-more'])" :key="item.title">
              <v-list-item-avatar>
                <v-icon :class="[item.iconClass]" v-text="item.icon"></v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="title" v-text="item.title"></v-list-item-title>
                <v-list-item-subtitle v-html="item.text[0]"></v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-btn icon>
                  <v-icon color="accent">mdi-check</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-btn text color="ma-2 accent-4" :to="{ name: 'features' }">Learn More About Features</v-btn>
          <v-spacer></v-spacer>
          <v-btn outlined class="ma-2" color="primary" :to="{ name: 'signup' }">Sign Up</v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({}),
  computed: {
    ...mapGetters("content", ["features"])
  },
  methods: {
    featuresByType(type) {
      return this.features.filter(function(feature) {
        type = typeof type === "object" ? type : [type];
        return type.includes(feature.type);
      });
    }
  }
};
</script>